// Pedidos vindos de /order (loja) trazem ProductID populado (objeto do
// produto); pedidos montados na venda balcão guardam só o id (string).
// Normaliza os dois formatos pro mesmo valor de comparação.
export default function getProductId(product) {
  return product?.ProductID?._id || product?.ProductID;
}
